import React, { useState, useEffect } from "react";
import Header from "../components/shared/header";
import { categoryList } from "../data/categories";
import { axiosPrivate } from "../api/axios";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useParams } from "react-router-dom";

const GET_QUERY_BY_ID = "/getQuery";
const EditQuery = () => {
  const params = useParams();
  const [category, setCategory] = useState("");
  const [editQuery, setEditQuery] = useState(null);
  const [subject, setSubject] = useState();
  const [startDate, setStartDate] = useState();
  const [comment, setComment] = useState();

  const getData = async () => {
    const response = await axiosPrivate.get(`${GET_QUERY_BY_ID}/${params.id}`);
    setEditQuery(response.data);
  };
  useEffect(() => {
    getData();
  }, []);
  console.log(editQuery);
  return (
    <div>
      <Header />
      <div className="container">
        <div className="row">
          <div className="col-12">
            <section className="query-container">
              <h1 className="text-center">Edit Query</h1>
              <form>
                <div className="form-group d-flex flex-column-reverse position-relative">
                  <select
                    onChange={(e) => setCategory(e.target.value)}
                    id="issue_categories"
                    name="issue_categories"
                    className="form-control"
                  >
                    <option>Select your department</option>
                    {categoryList.map((category, index) => {
                      return (
                        <option
                          key={index}
                          defaultValue={
                            editQuery === null ? category : editQuery.categoryId
                          }
                        >
                          {category.id}. {category.category}
                        </option>
                      );
                    })}
                  </select>
                  <label htmlFor="issue_categories">Department</label>
                </div>
                <div className="form">
                  <div className="form-group d-flex flex-column-reverse position-relative">
                    <input
                      type="text"
                      id="phoneNumber"
                      defaultValue={
                        editQuery === null ? subject : editQuery.subject
                      }
                      className="form-control"
                      onChange={(e) => {
                        setSubject(e.target.value);
                      }}
                      autoComplete="off"
                    />
                    <label htmlFor="phoneNumber">Subject</label>
                  </div>
                  <div className="form-group d-flex flex-column-reverse position-relative">
                    <textarea
                      rows={6}
                      type="text"
                      defaultValue={
                        editQuery === null
                          ? comment
                          : editQuery.comments[0].comment
                      }
                      id="comment"
                      onChange={(e) => {
                        setComment(e.target.value);
                      }}
                      className="form-control"
                      autoComplete="off"
                    />
                    <label htmlFor="phoneNumber">
                      Describe the issues in detail
                    </label>
                  </div>
                  <div className="form-group d-flex flex-column-reverse position-relative">
                    <DatePicker
                      dateFormat="yyy/mm/dd"
                      value={startDate}
                      className="form-control"
                      onChange={(date) => {
                        const d = moment(new Date(date)).format("YYYY-MM-DD");
                        setStartDate(d);
                      }}
                    />
                    <label htmlFor="duedate">Due Date</label>
                  </div>
                  <div className="form-group d-flex flex-column-reverse position-relative">
                    <input
                      type="file"
                      id="file"
                      className="form-control"
                      autoComplete="off"
                      multiple
                    />
                    <label htmlFor="custom-file-label">file</label>
                  </div>
                </div>
                <div className="btn-area">
                  <button className="btn btn-primary btn-h float-right">
                    Update Query
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EditQuery;
